/* NEX cart: compact upsell bars for the offers not started yet; they share one list with the active meter, ordered by stylesheet (winter first, summer last) */
(function () {
  'use strict';
  /* any link to /cart (with or without preview params) opens the drawer instead of loading a page */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.closest('.cd')) return;
    var p;
    try { p = new URL(a.getAttribute('href'), location.href).pathname.replace(/\/+$/, ''); } catch (er) { return; }
    if (!/\/cart$/.test(p) || /\/cart$/.test(location.pathname.replace(/\/+$/, ''))) return;
    if (!window.NexCart) return;
    e.preventDefault(); e.stopPropagation();
    var m = document.querySelector('[data-drawer].is-open [data-menu-close]'); if (m) m.click();
    window.NexCart.open();
  }, true);

  var root = document.querySelector('[data-cart]');
  var body = root && root.querySelector('[data-cart-body]');
  if (!body) return;
  var ALL = [
    { k: 'hoodie', t: 'Buy 3 hoodies or crewnecks', r: '4th 50% off' },
    { k: 'cap', t: 'Buy 3 hats', r: '4th FREE' },
    { k: 'tee', t: 'Buy 3 tees', r: 'FREE hat' }
  ];
  var busy = false;
  function run() {
    if (busy) return; busy = true;
    var offers = body.querySelector('.cd__offers');
    var ann = body.querySelector('.cd__ann'); if (ann) ann.remove();
    if (offers && body.querySelector('.cd__lines')) {
      [].forEach.call(offers.querySelectorAll('.om--mini'), function (n) { n.remove(); });
      ALL.filter(function (o) { return !offers.querySelector('.om--' + o.k); }).forEach(function (o) {
        var d = document.createElement('div');
        d.className = 'om om--mini om--' + o.k;
        d.innerHTML = '<button type="button" class="mini__b" data-pick="' + o.k + '"><span class="mini__t">' + o.t + '</span><span class="mini__p"><i></i><i></i><i></i><i class="g"></i></span><b>' + o.r + '</b><u>+</u></button>';
        offers.appendChild(d);
      });
    }
    setTimeout(function () { busy = false; }, 0);
  }
  new MutationObserver(function () { if (!busy) run(); }).observe(body, { childList: true });
  run();
})();
